"use strict";
/* globals module */
/**
 * @module commerceInvoiceRoute
 * @description Baasic Commerce Invoice Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Invoice Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var __1 = require("../");
var CommerceInvoiceRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceInvoiceRoute, _super);
    function CommerceInvoiceRoute(commerceInvoiceStreamsRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.commerceInvoiceStreamsRoute = commerceInvoiceStreamsRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/invoices/{?customerId,invoiceStatusId,subscriptionId,dateCreatedMin,dateCreatedMax,searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/invoices/{id}/{?embed,fields}';
        _this.updateRoute = 'commerce/invoices/{id}';
        _this.deleteRoute = 'commerce/invoices/{id}';
        return _this;
    }
    Object.defineProperty(CommerceInvoiceRoute.prototype, "streams", {
        get: function () {
            return this.commerceInvoiceStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce invoice route which can be expanded with additional options. Supported items are:
     * - `customerId` - The customer identifier.
     * - `invoiceStatusId` - A invoice status unique identifier.
     * - `subscriptionId` - A subscription unique identifier.
     * - `dateCreatedMin` - A date created minimum date filter.
     * - `dateCreatedMax` - A date created maximum date filter.
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceInvoiceRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceInvoiceRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceInvoiceRoute.get(id, options);
     **/
    CommerceInvoiceRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route doesn't expose any properties.
     * @method
     * @example commerceInvoiceRoute.update(data);
     **/
    CommerceInvoiceRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this route doesn't expose any properties.
     * @method
     * @example commerceInvoiceRoute.delete(data);
     **/
    CommerceInvoiceRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceInvoiceRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceInvoiceStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceInvoiceStreamsRoute !== "undefined" && __1.CommerceInvoiceStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceInvoiceRoute);
    return CommerceInvoiceRoute;
}(common_1.BaseRoute));
exports.CommerceInvoiceRoute = CommerceInvoiceRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
